import React from 'react';

export function Spinner({ label }) {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="relative w-14 h-14">
        <div className="absolute inset-0 rounded-full border-2 border-[#e4b44e]/20" />
        <div className="absolute inset-0 rounded-full border-2 border-t-[#e4b44e] animate-spin" />
      </div>
      {label && <div className="mt-4 text-xs tracking-widest text-white/50">{label}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="py-24 text-center border border-dashed border-white/10 rounded-3xl">
      {Icon && (
        <div className="inline-flex w-16 h-16 rounded-full bg-[#e4b44e]/10 border border-[#e4b44e]/30 items-center justify-center mb-4">
          <Icon className="w-6 h-6 text-[#f4d896]" />
        </div>
      )}
      <h3 className="font-display text-2xl font-bold text-white mb-2">{title}</h3>
      {subtitle && <p className="text-white/50 max-w-md mx-auto">{subtitle}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
